module.exports = __webpack_public_path__ + "img/guide_1_4.e4e665e4.svg";